// Global Console Logger Service
// Fängt alle console.log, console.error, console.warn Aufrufe ab

class ConsoleLoggerService {
  constructor() {
    this.logs = [];
    this.listeners = [];
    this.isInitialized = false;
  }

  init() {
    if (this.isInitialized) return;

    // Speichere originale console Methoden
    this.originalLog = console.log;
    this.originalError = console.error;
    this.originalWarn = console.warn;
    this.originalInfo = console.info;

    // Überschreibe console Methoden
    console.log = (...args) => {
      this.originalLog(...args);
      this.addLog('log', args);
    };

    console.error = (...args) => {
      this.originalError(...args);
      this.addLog('error', args);
    };

    console.warn = (...args) => {
      this.originalWarn(...args);
      this.addLog('warn', args);
    };

    console.info = (...args) => {
      this.originalInfo(...args);
      this.addLog('info', args);
    };

    this.isInitialized = true;
    console.log('🐛 Console Logger initialisiert - alle Logs werden aufgezeichnet');
  }

  addLog(type, args) {
    const timestamp = new Date().toLocaleTimeString('de-DE');
    const message = args.map(arg => {
      if (typeof arg === 'object') {
        try {
          return JSON.stringify(arg, null, 2);
        } catch (e) {
          return String(arg);
        }
      }
      return String(arg);
    }).join(' ');

    const logEntry = { type, message, timestamp };
    this.logs.push(logEntry);

    // Benachrichtige alle Listener
    this.listeners.forEach(listener => listener(this.logs));
  }

  getLogs() {
    return this.logs;
  }

  clearLogs() {
    this.logs = [];
    this.listeners.forEach(listener => listener(this.logs));
  }

  subscribe(listener) {
    this.listeners.push(listener);
    // Sende sofort die aktuellen Logs
    listener(this.logs);

    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  restore() {
    if (!this.isInitialized) return;

    console.log = this.originalLog;
    console.error = this.originalError;
    console.warn = this.originalWarn;
    console.info = this.originalInfo;

    this.isInitialized = false;
  }
}

// Singleton Instanz
const consoleLogger = new ConsoleLoggerService();

export default consoleLogger;
